module.exports = __webpack_public_path__ + "img/broadcast-tower.26fd2d6.svg";